import { render, staticRenderFns } from "./BookingErrorModal.vue?vue&type=template&id=2551ddfc"
import script from "./BookingErrorModal.vue?vue&type=script&lang=js"
export * from "./BookingErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports